import Link from 'next/link'

export default function CTACard({ href, imgSrc, alt, heading, description, width, height }) {
  return (
    <div className='cardContainer'>
      <Link legacyBehavior href={href}>
        <a>
          <div className='cardWrapper flex alignEnd'>
            <img className='cardBackground' src={imgSrc} alt={alt} width={width} height={height} />
            <div className='textWrapper'>
              <h3>{heading}</h3>
              <p>{description}</p>
            </div>
          </div>
        </a>
      </Link>

      <style jsx>{`
        .cardWrapper {
          position: relative;
          top: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: 1rem;
        }

        img {
          width: 100%;
          height: auto;
        }

        .textWrapper {
          position: absolute;
          bottom: 0;
          width: 100%;
          z-index: 1;
          padding: 2.5rem 3.9rem;
          background: linear-gradient(0deg, #000 -25%, transparent 100%);

          h3 {
            color: #fff;
            line-height: 3.8rem;
            font-size: 2.8rem;
          }

          p {
            color: #fff;
            line-height: 2.3rem;
            font-size: 1.8rem;
          }
        }

        @media (max-width: 1024px) {
          .textWrapper {
            padding: 2rem;

            h3 {
              line-height: 2.6rem;
              font-size: 2rem;
            }

            p {
              line-height: 1.8rem;
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
